angular.module('tgaAdmin').factory('socketService', [
  'socketFactory',
  'envService',
  'userService',
  function (socketFactory, envService, userService) {
    function createInstructorSocket(slug, instructor_token = '', autoConnect = true) {
      const instructor = userService.getUserData().username;
      const webSocketAddress = envService.read('webSocketAddress');
      return socketFactory({
        ioSocket: io.connect(webSocketAddress, {
          transports: ['websocket'],
          autoConnect,
          query: {
            slug,
            instructor,
            token: instructor_token,
          },
        }),
      });
    }

    function bindEventHandlers(socket, subscriptions) {
      subscriptions.forEach((s) => {
        socket.on(s.event, s.callback);
      });
    }

    return {
      createInstructorSocket,
      bindEventHandlers,
    };
  },
]);
